import React, { useState } from "react";
import { mediaSrc } from "../lib/upload";

/**
 * Image that degrades gracefully. Listing photos are served from a permanent
 * app URL (`/api/media/<id>`), but a row can still be missing (deleted upload,
 * bad legacy URL, offline third-party host). When that happens we render a
 * branded placeholder instead of a broken-image icon.
 */
export default function SafeImage({ src, alt = "", className = "", fallback = null, testId }) {
  const [failed, setFailed] = useState(false);
  const url = mediaSrc(src);

  if (!url || failed) {
    return (
      fallback || (
        <div
          data-testid={testId ? `${testId}-fallback` : "image-fallback"}
          className={`w-full h-full flex items-center justify-center font-display text-2xl opacity-30 ${className}`}
          style={{ color: "var(--gf-text)", background: "var(--gf-bg-soft)" }}
          aria-label={alt || "Image unavailable"}
        >
          Book<span style={{ color: "var(--gf-accent)" }}>Freely</span>
        </div>
      )
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      data-testid={testId}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
